import React, { Component } from 'react';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';

import bCross from '../assets/bCross.svg';

import '../styles/components/info.scss';


export default class Info extends Component {

    state = {
      open: false
    }

    constructor(props) {
      super(props);
      this.message = null;
    }

    componentDidMount() {
      TweenMax.set(this.message, {
        opacity: 0,
        y: 20
      })
    }

    componentDidUpdate() {
      TweenMax.to(this.message, .5, {
        opacity: this.state.open ? 1 : 0,
        y: this.state.open ? 0 : 20
      })
    }

    toggleMessage = () => {
      this.setState({open: !this.state.open})
    }

    render() {

        return (
          <div
            ref={this.props.myRef}
            className={`highlight ${this.props.extraClass}`}
          >
            <div className="top">
              <span className="name">{this.props.name}</span>
              <div className="circle" onClick={ this.toggleMessage }>
                <div className="inner">
                  <img src={ bCross } alt='' />
                </div>
              </div>
              <span className="secondName">{this.props.secondName}</span>
            </div>
            <div
              className="bottom"
              ref={div => this.message = div}
            >
              {this.props.message}
            </div>
          </div>
        );
    }
}
